import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { Observable } from "rxjs";
import { PaginatedModel } from "../../dominio/paginated-model";
import { IGridifyQuery } from "gridify-client";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { FinanciadoraIntegradorModel } from "../models/financiadora-integrador-model";

export class ListarFinanciadoraIntegradorResponse {
  results?: FinanciadoraIntegradorModel[];
  pagination?: PaginatedModel;
}

export class DetalharFinanciadoraIntegradorResponse {
  result?: FinanciadoraIntegradorModel;
}

@Injectable({
  providedIn: "root",
})
export class FinanciadoraIntegradorService {
  constructor(private http: HttpClient, private queryFilterService: QueryFilterService) {}

  buscarFinanciadoras(
    idCliFor: number,
    queryFilter: IGridifyQuery | null = null
  ): Observable<ListarFinanciadoraIntegradorResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarFinanciadoraIntegradorResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/integrador/${idCliFor}/financiadoras`,
      {
        params: params,
      }
    );
  }

  salvarFinanciadora(idCliFor: number, data: FinanciadoraIntegradorModel) {
    if (data.id === 0) {
      return this.http.post<DetalharFinanciadoraIntegradorResponse>(
        `${globals.apiUrl}/api/v2/financiamentos/resources/integrador/${idCliFor}/financiadoras`,
        {
          idFinanciadora: data.financiadora.id,
          apto: data.apto,
          situacao: data.situacao,
        }
      );
    } else {
      return this.http.put<DetalharFinanciadoraIntegradorResponse>(
        `${globals.apiUrl}/api/v2/financiamentos/resources/integrador/${idCliFor}/financiadoras/${data.id}`,
        {
          apto: data.apto,
          situacao: data.situacao,
        }
      );
    }
  }

  buscarIntegradores(
    idFinanciadora: number,
    queryFilter: IGridifyQuery | null = null
  ): Observable<ListarFinanciadoraIntegradorResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarFinanciadoraIntegradorResponse>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/integradores`,
      {
        params: params,
      }
    );
  }

  exportarIntegradores(
    idFinanciadora: number,
    queryFilter: IGridifyQuery | null = null
  ): Observable<Blob> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get(
      `${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/integradores/exportar`,
      {
        params: params,
        responseType: "blob",
      }
    );
  }

  importarIntegradores(
    idFinanciadora: number,
    formData: FormData
  ): Observable<void> {
    return this.http.post<void>(
      `${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/integradores/importar`,
      formData
    );
  }

  salvarIntegrador(idFinanciadora: number, data: FinanciadoraIntegradorModel) {
    if (data.id === 0) {
      return this.http.post<DetalharFinanciadoraIntegradorResponse>(
        `${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/integradores`,
        {
          idClifor: data.idClifor,
          apto: data.apto,
          situacao: data.situacao,
        }
      );
    } else {
      return this.http.put<DetalharFinanciadoraIntegradorResponse>(
        `${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/integradores/${data.id}`,
        {
          apto: data.apto,
          situacao: data.situacao,
        }
      );
    }
  }
}
